import _ from 'lodash';
import * as utils from '../../common/utils';
import { appBuilder } from './appBuilder/appBuilder';

const EXTRA_NAMESPACES = {
  appBuilder,
};

export default _.pick(EXTRA_NAMESPACES, utils.getExtraNamespaces());
